import { render, staticRenderFns } from "./AppIconArrowDropdown.vue?vue&type=template&id=459719d5&scoped=true&"
import script from "./AppIconArrowDropdown.vue?vue&type=script&lang=js&"
export * from "./AppIconArrowDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459719d5",
  null
  
)

export default component.exports